module.exports = __webpack_public_path__ + "Simple-Line-Icons.0cb0b9c589c0624c9c78.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/simple-line-icons/Simple-Line-Icons.woff2?v=2.4.0
// module id = ../../../../../src/assets/fonts/simple-line-icons/Simple-Line-Icons.woff2?v=2.4.0
// module chunks = 40